<template>
  <div class="second">
    <!-- Hero 区域 -->
    <div class="solve">
      <div class="hero-text-container">
        <h1 class="">一切营销困境的本质都是流量困境</h1>
        <p class="">越璋--以流量为引擎，驱动品牌确定性增长</p>
        <div class="desc">
          <div>越璋深耕流量获取与转化多年，积累了丰富的行业经验，形成了一套完整的流量增长模型。我们</div>
          <div>致力于帮助企业解决流量暴增的可能性，实现可持续的品牌增长。</div>
        </div>
      </div>
      <div class="hero-m-container">
        <div class="con">
          <div class="">
            <img src="../../assets/images/lljjfa/xhsqyyy.png">
          </div>
          <h2 class="">小红书全域运营</h2>
          <p class="">报备+聚光，水下笔记保ROI，官号代运营</p>
        </div>
        <div class="con">
          <div class="">
            <img src="../../assets/images/lljjfa/drsy.png">
          </div>
          <h2 class="">达人私域保ROI/CPA</h2>
          <p class="">短周期ROI/GMV/CPA对赌，助力新品冷启动爆品抢市场</p>
        </div>
        <div class="con">
          <div class="">
            <img src="../../assets/images/lljjfa/dptnrzh.png">
          </div>
          <h2 class="">内容跨域整合营销</h2>
          <p class="">多维度展示、多平台创作、多渠道赋能</p>
        </div>
      </div>
    </div>

    <!-- 流量串联引擎 区域：移除白圈，保留三圆+内层线圈 -->
    <div class="LD-box">
      <div class="llzz-title">数据漏斗构建 UV价值锚定</div>
      <p>为品牌定制数据漏斗模型</p>
      <div class="circle-container">
        <!-- 淘宝圆：已移除白色边框小圆 -->
        <div class="circle circle-taobao">
          <div class="inner-ring"></div> <!-- 保留内层线圈 -->
          <div class="circle-title">淘宝</div>
          <img src="../../assets/images/lljjfa/策略中心.png" class="logo logo-1" alt="logo">
          <img src="../../assets/images/lljjfa/生意参谋.png" class="logo logo-2" alt="logo">
          <img src="../../assets/images/lljjfa/淘宝星河.png" class="logo logo-3" alt="logo">
          <img src="../../assets/images/lljjfa/达摩盘.png" class="logo logo-4" alt="logo">
          <img src="../../assets/images/lljjfa/品牌数据引擎.png" class="logo logo-5" alt="logo">
          <div class="tag tag-uds">UDS</div>
        </div>
        <!-- 小红书圆：已移除白色边框小圆 -->
        <div class="circle circle-xhs">
          <div class="inner-ring"></div> <!-- 保留内层线圈 -->
          <div class="circle-title">小红书</div>
          <img src="../../assets/images/lljjfa/小红书蒲公英.png" class="logo logo-1" alt="logo">
          <img src="../../assets/images/lljjfa/CID.png" class="logo logo-2" alt="logo">
          <img src="../../assets/images/lljjfa/UDS.png" class="logo logo-3" alt="logo">
          <img src="../../assets/images/lljjfa/聚光.png" class="logo logo-4" alt="logo">
          <img src="../../assets/images/lljjfa/91489918d79ef6b585acc0308df392cf542c3bfe.png" class="logo logo-5"
            alt="logo">
        </div>
        <!-- 京东圆：已移除白色边框小圆 -->
        <div class="circle circle-jd">
          <div class="inner-ring"></div>
          <div class="circle-title">京东</div>
          <img src="../../assets/images/lljjfa/11b994cfeb2be8be.png" class="logo logo-1" alt="logo">
          <img src="../../assets/images/lljjfa/59d2a1cb26c0831d (1).png" class="logo logo-2" alt="logo">
          <img src="../../assets/images/lljjfa/Nlnt任拓-6.png" class="logo logo-3" alt="logo">
          <img src="../../assets/images/lljjfa/未标题-9.png" class="logo logo-4" alt="logo">
          <div class="tag tag-cid">CID</div>
        </div>
      </div>
      <div class="tree-title" id="tree">全域流量价值洞察，科学分配预算，驱动高效转化流转</div>
    </div>
    <!-- 全域流量价值洞察图片盒子 -->
    <div class="jjfa-top-img-box">
      <img src="../../assets/images/lljjfa/容器 57@1x.png" alt="解决方案顶部装饰图">
    </div>

    <!-- 详细解决方案 区域 -->
    <div class="jjfa">
      <div class="jjfa-container">
        <div class="jjfa-title" id="jjfa">详细解决方案</div>
        <div class="jjfa-content">
          <div class="item xhsqyyy">
            <div class="title">
              <img src="../../assets/images/lljjfa/xhsqyyy.png">
              <span>小红书全域运营</span>
            </div>
            <div class="content">
              <div class="con">
                <div class="title">报备+聚光</div>
                <div class="text">精选优质达人，放大爆款内容，低成本种草</div>
              </div>
              <div class="con">
                <div class="title">水下笔记保ROI</div>
                <div class="text">拒绝无效种草！我们只和敢签对赌协议的素人合作，自然流也能保ROI</div>
              </div>
              <div class="con">
                <div class="title">CID/UDS</div>
                <div class="text">强技术驱动，融合策略+执行+自动化能力ROI对赌，服务费分层</div>
              </div>
            </div>
          </div>
          <div class="drsy">
            <div class="title">
              <img src="../../assets/images/lljjfa/drsy.png">
              <span>达人私域保ROI/CPA</span>
            </div>
            <div class="content">
              <div class="con">
                <div class="title">短周期ROI/GMV对赌</div>
                <div class="icon-text">
                  <div class="text">
                    <i class="el-icon-success"></i>
                    <span>全平台、全品类ROI对赌，效果是唯一准则</span>
                  </div>
                  <div class="text">
                    <i class="el-icon-success"></i>
                    <span>新品冷启动与爆款冲量</span>
                  </div>
                  <div class="text">
                    <i class="el-icon-success"></i>
                    <span>低成本拉新</span>
                  </div>
                </div>
              </div>
              <div class="con">
                <div class="title">私域撬动公域流量模型</div>
                <div class="icon-text">
                  <div class="text">
                    <i class="el-icon-success"></i>
                    <span>私域行为提升店铺权重</span>
                  </div>
                  <div class="text">
                    <i class="el-icon-success"></i>
                    <span>撬动平台免费流量</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="item dptnrzh" id="dptnrzh">
            <div class="title">
              <img src="../../assets/images/lljjfa/dptnrzh.png">
              <span>内容跨域整合营销</span>
            </div>
            <div class="content">
              <div class="con">
                <div class="title">多维度展示</div>
                <div class="text">讲一个人的故事，解一类人的难题——把产品价值藏在细节里。</div>
              </div>
              <div class="con">
                <div class="title">多平台创作</div>
                <div class="text">以用户为中心，以平台为语境，让核心故事在多端高效共鸣</div>
              </div>
              <div class="con">
                <div class="title">多渠道收割</div>
                <div class="text">内容平台种信任，货架电商收销量</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 开启您的流量增长之旅 区域 -->
    <div class="llzz">
      <div class="llzz-container">
        <div class="llzz-title">选对我们，驶入流量超车道</div>
        <p>别人在赌流量,我们在造确定性——您的弯道超车，从这里开始</p>
        <div class="llzz-content">
          <el-button @click="ljzx" style="background-color: #F20303;height: 42px" type="primary" size="medium">
            立即咨询
          </el-button>
          <el-button @click="zxzx" style="background-color: #FF6700;border-color: #FF6700;height: 42px" type="primary" size="medium">
            在线咨询
          </el-button>
        </div>
      </div>
    </div>

    <LjzxDialog :visible.sync="ljzxOpen" @closeDialog="closeDialog"></LjzxDialog>

    <OnlineDialog :visible.sync="zxzxOpen" @closeDialog="closeZxzxDialog"></OnlineDialog>
  </div>
</template>

<script>
import LjzxDialog from "@/components/Dialog/ljzxDialog.vue";
import OnlineDialog from "@/components/Dialog/onlineDialog.vue";
import eventBus from '@/utils/eventBus';

export default {
  components: { LjzxDialog, OnlineDialog },
  data() {
    return {
      rjuv: 1000,
      gmv: 5000,
      zhl: 2.5,
      kdj: 200,
      uvValue: '5.00',
      modeName: '转化率',
      modeFormula: '转化率 * 客单价',
      ljzxOpen: false,
      zxzxOpen: false
    };
  },
  created() { },
  mounted() {
    // 路由锚点平滑滚动
    const targetId = this.$route.query.scrollTo;
    if (targetId) {
      this.$nextTick(() => {
        this.scrollToEl(targetId);
      });
    }
    // 监听全局滚动事件
    this.scrollHandler = (elementId) => {
      this.scrollToEl(elementId);
    };
    eventBus.$on('scrollToPageEl', this.scrollHandler);
  },
  beforeDestroy() {
    // 移除事件监听，防止内存泄漏
    eventBus.$off('scrollToPageEl', this.scrollHandler);
  },
  methods: {
    scrollToEl(elementId) {
      const targetDiv = document.querySelector(`#${elementId}`);
      if (targetDiv) {
        targetDiv.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      }
    },
    zhlInput() {
      this.gmv = '';
      this.rjuv = '';
    },
    gvmInput() {
      this.zhl = '';
      this.kdj = '';
    },
    ljzx() {
      this.ljzxOpen = true;
    },
    closeDialog() {
      this.ljzxOpen = false;
    },
    zxzx() {
      this.zxzxOpen = true;
    },
    closeZxzxDialog() {
      this.zxzxOpen = false;
    },
    calcValue() {
      if (this.zhl && this.kdj) {
        const result = Math.round(this.zhl / 100 * this.kdj * 100) / 100;
        this.uvValue = result.toFixed(2);
        this.modeName = '转化率';
        this.modeFormula = '转化率 * 客单价';
      } else if (this.gmv && this.rjuv) {
        const result = Math.round(this.gmv / this.rjuv * 100) / 100;
        this.uvValue = result.toFixed(2);
        this.modeName = 'GMV';
        this.modeFormula = 'GMV / 日均UV';
      }
    }
  }
};
</script>

<style lang='scss' scoped>
body {
  color: rgba(0, 0, 0, 0.85);
  margin: 0;
  padding: 0;
}

.second {
  background-color: #f7f7f7;
  font-size: 15px;
  min-width: 1200px;

  // Hero区域样式
  .solve {
    margin: 0 auto;
    margin-top: 100px;
    width: 100%;
    height: 580px;
    background-color: #F20303;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;

    .hero-text-container {
      margin-top: 100px;
      text-align: center;
      height: 50%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #ffffff;

      h1 {
        font-size: xxx-large;
        color: #ffffff;
        margin: 0 0 20px 0;
      }

      p {
        font-size: large;
        padding: 0 20px;
        margin: 0 0 15px 0;
      }

      .desc {
        max-width: 800px;
        line-height: 1.6;
        font-size: 16px;
      }
    }

    .hero-m-container {
      width: 80%;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 50px;
      padding-top: 20px;

      .con {
        flex: 1;
        height: 220px;
        padding: 15px;
        background-color: #ffffff;
        border: 1px solid #f4f4f5;
        border-radius: 15px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        box-sizing: border-box;

        >div {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 8px;
        }

        img {
          width: 60px;
          vertical-align: middle;
          display: block;
        }

        h2 {
          padding: 10px 0;
          font-weight: bold;
          margin: 0;
          font-size: 20px;
        }

        p {
          font-size: 16px;
          color: #606875;
          margin: 0;
          line-height: 1.5;
        }
      }
    }
  }

  // 三圆核心区域样式：已移除白色边框小圆相关样式
  .LD-box {
    width: 100%;
    background-color: #ffffff;
    padding: 60px 0;
    margin: 0 auto;
    text-align: center;

    .llzz-title {
      text-align: center;
      padding: 0 20px 15px 20px;
      font-size: xx-large;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
      margin: 0;
    }

    p {
      font-size: 16px;
      color: #666;
      margin: 0 0 30px 0;
      line-height: 1.5;
    }

    .circle-container {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      width: 100%;
      max-width: 1000px;
      margin: 0 auto;
    }

    // 主圆基础样式：移除small-circle相关代码
    .circle {
      width: 380px;
      height: 380px;
      border-radius: 50%;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-weight: bold;
      box-sizing: border-box;
      z-index: 1;

      // 内层线圈样式：保留
      .inner-ring {
        position: absolute;
        width: 75%;
        height: 75%;
        border: 2px solid rgba(255, 255, 255, 0.6);
        border-radius: 50%;
        z-index: 2;
      }

      // 圆内标题：保留
      .circle-title {
        font-size: 36px;
        margin-bottom: 20px;
        z-index: 3;
        position: relative;
      }

      // Logo样式：保留
      .logo {
        width: 70px;
        height: 70px;
        border-radius: 50%;
        background-color: #fff;
        padding: 5px;
        position: absolute;
        object-fit: contain;
        z-index: 3;
      }

      // 标签样式（UDS/CID）：保留
      .tag {
        position: absolute;
        background-color: #fff;
        color: #333;
        padding: 6px 12px;
        border-radius: 20px;
        font-size: 16px;
        font-weight: normal;
        top: 50%;
        transform: translateY(-50%);
        z-index: 3;
      }
    }

    // 淘宝圆：保留所有样式，移除small-circle背景色代码
    .circle-taobao {
      background-color: #EA5919;
      z-index: 1;

      // Logo定位
      .logo-1 {
        top: 40px;
        left: 90px;
      }

      .logo-2 {
        top: 50px;
        right: 80px;
      }

      .logo-3 {
        top: 190px;
        left: 25px;
      }

      .logo-4 {
        top: 250px;
        right: 60px;
      }

      .logo-5 {
        top: 290px;
        left: 130px;
      }

      // UDS标签
      .tag-uds {
        right: -30px;
      }
    }

    // 小红书圆：保留所有样式，移除small-circle背景色代码
    .circle-xhs {
      background-color: #F20303;
      margin: 0 -80px;
      z-index: 2;

      // Logo定位
      .logo-1 {
        top: 20px;
        left: 160px;
      }

      .logo-2 {
        top: 140px;
        right: 15px;
        display: inline-block;
        background-color: #F68989;
      }

      .logo-3 {
        top: 145px;
        left: 15px;
        display: inline-block;
        background-color: #FCCD9D;
      }

      .logo-4 {
        bottom: 45px;
        right: 80px;
      }

      .logo-5 {
        bottom: 45px;
        left: 80px;
      }
    }

    // 京东圆：保留所有样式，移除small-circle背景色代码
    .circle-jd {
      background-color: #FF3F4B;
      z-index: 1;

      // Logo定位
      .logo-1 {
        top: 25px;
        left: 160px;
      }

      .logo-2 {
        top: 145px;
        right: 20px;
      }

      .logo-3 {
        bottom: 50px;
        left: 80px;
        display: inline-block;
        background-color: #ED95C5;
      }

      .logo-4 {
        bottom: 45px;
        right: 80px;
      }

      // CID标签
      .tag-cid {
        left: -30px;
      }
    }

    .tree-title {
      text-align: center;
      font-size: xx-large;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
      margin-top: 20px;

    }
  }

  // 全域流量价值洞察图片盒子样式：保留
  .jjfa-top-img-box {
    width: 100%;
    background-color: #ffffff;
    padding: 0px 0;
    text-align: center;

    .tree-title {
      text-align: center;
      font-size: xx-large;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
      margin-bottom: 20px;
    }

    img {
      max-width: 80%;
      height: auto;
      display: inline-block;
    }
  }

  // 详细解决方案区域样式：保留
  .jjfa {
    width: 100%;
    height: 770px;
    background-color: #ffffff;

    .jjfa-container {
      width: 80%;
      background-color: #ffffff;
      margin: 0 auto;
      padding-top: 50px;

      .jjfa-title {
        text-align: center;
        font-size: xx-large;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.85);
        margin-bottom: 40px;
      }

      .jjfa-content {
        display: flex;
        flex-direction: column;
        gap: 35px;



        .item {
          .title {
            display: flex;
            align-items: center;
            gap: 5px;
            margin-bottom: 15px;

            img {
              width: 40px;
            }

            span {
              font-size: large;
              font-weight: bold;
              font-size: 20px;
            }
          }

          .content {
            margin-top: 15px;
            display: flex;
            align-items: center;
            gap: 40px;

            .con {
              height: 125px;
              padding: 20px;
              border: 1px solid #d4d7db;
              border-radius: 15px;
              flex: 1;

              .title {
                font-weight: bold;
                font-size: large;
                margin-bottom: 4px;
                display: block;
              }

              .text {
                color: #9399a2;
                font-size: 16px;
                padding: 0;
                line-height: 1.5;
              }
            }
          }
        }

        .xhsqyyy,
        .dptnrzh {
          .content {
            .con {
              flex: 1;
            }
          }
        }

        .drsy {
          .title {
            display: flex;
            align-items: center;
            gap: 5px;
            margin-bottom: 15px;

            img {
              width: 40px;
            }

            span {
              font-size: large;
              font-weight: bold;
              font-size: 20px;
            }
          }

          .content {
            margin-top: 15px;
            display: flex;
            align-items: center;
            gap: 40px;

            .con {
              height: 125px;
              padding: 20px;
              border: 1px solid #d4d7db;
              border-radius: 15px;
              flex: 1;

              .title {
                font-weight: bold;
                font-size: large;
                margin-bottom: 4px;
                display: block;
              }

              .text {
                color: #9399a2;
                font-size: 16px;
                padding: 0;
                line-height: 1.1;
              }
            }
          }

          .content {
            .con {
              height: 162px;
              width: calc(34% - 40px);
              flex: none;

              .icon-text {
                .text {
                  display: flex;
                  align-items: center;
                  margin-bottom: 8px;

                  i {
                    color: #F20303;
                    margin-right: 8px;
                  }

                  span {
                    margin-left: 0;
                    font-size: 16px;
                  }
                }
              }

              .text {
                padding: 5px 0;
              }
            }
          }
        }
      }
    }
  }

  // 立即咨询区域样式：保留
  .llzz {
    width: 100%;
    height: 266px;
    background-color: #ffffff;
    border-top: 1px solid #f4f4f5;

    .llzz-container {
      width: 80%;
      background-color: #ffffff;
      margin: 0 auto;
      text-align: center;
      padding-top: 50px;

      .llzz-title {
        text-align: center;
        padding: 0 20px 15px 20px;
        font-size: xx-large;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.85);
        margin: 0;
      }

      p {
        font-size: 16px;
        color: #666;
        margin: 0 0 30px 0;
        line-height: 1.5;
      }

      .llzz-content {
        margin-top: 0;

        button {
          color: #FFF;
          border-color: #FF6700;
        }
      }
    }
  }
}
</style>